// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skill__item {\n  display: inline-flex;\n  font-size: 0.9rem;\n  padding: 0px 5px;\n  line-height: 1.2rem;\n  align-items: center;\n  background-color: var(--primary_light_color);\n\n  border-radius: 5px;\n  margin-right: 4px;\n}\n.skill__item img {\n  height: 14px;\n  width: 14px;\n  border: none;\n  margin-left: 6px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
